import type { RootState } from "../model/store";

export default function getMaxMaps(
  me: RootState["oidc"]["me"],
  selectedOrganization: RootState["app"]["organization"],
) {
  const memberships =
    me?.organizations.filter(({ status }) => {
      return status === "active";
    }) ?? [];
  const organization = memberships.find(({ organization }) => {
    return selectedOrganization
      ? organization.slug === selectedOrganization.slug
      : memberships.length === 1;
  })?.organization;
  const limit = organization?.entitlements.max_maps;
  const maxNbMaps = typeof limit === "number" ? limit : null;
  const nbMaps = organization?.usage?.maps ?? 0;

  return {
    isMaxMapsReached: maxNbMaps !== null && nbMaps >= maxNbMaps,
    maxNbMaps,
    nbMaps,
  };
}
